import React from "react";
import { Grid, Typography } from "@material-ui/core";
import ReactDatePicker from "react-datepicker";
import { isEmpty } from "lodash";

import "./styles.scss";
import { Skeleton } from "@material-ui/lab";

export const FORM_DROPDOWN_LABEL_POSITION = Object.freeze({
  TOP: "TOP",
  LEFT: "LEFT",
});

const DatePicker = ({
  id = "",
  label,
  selectedDate,
  onChangeDate,
  maxDate,
  minDate,
  errorText,
  disabled,
  labelPosition,
  fullWidth,
  required,
  loading = false,
  showYearDropdown = false,
  yearDropdownItemCount = 80,
  showMonthDropdown,
}) => {
  let _minDate = !isEmpty(minDate) ? new Date(minDate) : undefined;
  let _maxDate = !isEmpty(maxDate) ? new Date(maxDate) : new Date();

  const containerProps = {
    direction:
      labelPosition === FORM_DROPDOWN_LABEL_POSITION.TOP ? "column" : "row",
    alignItems:
      labelPosition === FORM_DROPDOWN_LABEL_POSITION.TOP
        ? "flex-start"
        : "center",
  };

  const datePickerProps = {
    ...(showYearDropdown && {
      showYearDropdown: true,
      scrollableYearDropdown: true,
      yearDropdownItemNumber: yearDropdownItemCount,
    }),
  };

  const computedWrapperClassName = fullWidth ? "w-full" : "";
  const computedPickerClassName = `picker-input ${fullWidth ? "w-full" : ""}`;

  return (
    <Grid container direction="column" className="date-picker-container">
      <Grid item container className="gap-x-8 gap-y-8" {...containerProps}>
        <Typography variant="body2" className="label">
          {label}
          {required && <span> *</span>}
        </Typography>
        {loading ? (
          <Skeleton variant="rect" className="loading-skeleton" />
        ) : (
          <ReactDatePicker
            id={id}
            showIcon
            selected={selectedDate}
            fixedHeight
            className={computedPickerClassName}
            wrapperClassName={computedWrapperClassName}
            onChange={(date) => {
              onChangeDate(date);
            }}
            minDate={_minDate}
            maxDate={_maxDate}
            disabled={disabled}
            dateFormat="yyyy-MM-dd"
            placeholderText="Pick a date"
            showMonthDropdown={showMonthDropdown}
            {...datePickerProps}
          />
        )}
      </Grid>
      {errorText && (
        <Typography variant="caption" className="error-text">
          {errorText}
        </Typography>
      )}
    </Grid>
  );
};

export default DatePicker;
